// A soft two-note chime for in-app notifications, synthesised with the Web
// Audio API — no audio file to load, and quiet enough not to startle.

let ctx: AudioContext | null = null;
let unlockBound = false;

const getContext = (): AudioContext | null => {
  if (ctx) return ctx;
  const Ctor = window.AudioContext || (window as any).webkitAudioContext;
  if (!Ctor) return null;
  ctx = new Ctor();
  return ctx;
};

// Browsers keep an AudioContext suspended until the user interacts with the
// page. Resume it on the first click / key press so later chimes can play.
export const bindNotificationSoundUnlock = () => {
  if (unlockBound || typeof window === "undefined") return;
  unlockBound = true;
  const unlock = () => {
    const audio = getContext();
    if (audio && audio.state === "suspended") audio.resume().catch(() => {});
    window.removeEventListener("pointerdown", unlock);
    window.removeEventListener("keydown", unlock);
  };
  window.addEventListener("pointerdown", unlock);
  window.addEventListener("keydown", unlock);
};

const playTone = (audio: AudioContext, freq: number, start: number, duration: number, peak: number) => {
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, start);

  // Quick soft attack, long exponential fade — a bell-like "ting".
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);

  osc.connect(gain).connect(audio.destination);
  osc.start(start);
  osc.stop(start + duration + 0.05);
};

export const playNotificationSound = () => {
  // Every open tab receives the same stream event; only the one the user is
  // looking at chimes. Hidden tabs are covered by the OS push notification.
  if (typeof document !== "undefined" && document.visibilityState !== "visible") return;

  const audio = getContext();
  if (!audio || audio.state !== "running") return;

  const now = audio.currentTime;
  playTone(audio, 1046.5, now, 0.45, 0.06); // C6
  playTone(audio, 1568.0, now + 0.11, 0.6, 0.045); // G6
};
